import { withAlertHandler } from 'entoro-shared';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import OfferActionDialog from '../OfferActionDialog';

class OfferAction extends Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  request = async ({ message }) => {
    const {
      client,
      handleSnackbarError,
      setSnackbarMessage,
      offerId,
      mutation,
      refetchQueries,
    } = this.props;

    const { mutate } = client;

    const variables = {
      offerId,
      message,
    };

    try {
      if (variables.message) {
        await mutate({ mutation, variables, refetchQueries });
        this.handleClose();
        setSnackbarMessage(
          'Thank You for your interest. Someone will contact you shortly'
        );
      } else {
        setSnackbarMessage('Please can you enter a message?');
      }
    } catch (error) {
      this.handleClose();
      handleSnackbarError(error);
    }
  };

  render() {
    const { open } = this.state;
    const { title, dialogBody, enableMessage, linkForm } = this.props;

    return (
      <Fragment>
        <OfferActionDialog
          open={open}
          handleClose={this.handleClose}
          request={this.request}
          title={title}
          dialogBody={dialogBody}
          enableMessage={enableMessage}
        />
        {linkForm ? (
          <a
            href="javascript:void(0)"
            onClick={this.handleClickOpen}
          >
            Request Password
          </a>
        ) : (
          <button
            onClick={this.handleClickOpen}
            className='btn-small-outline w-button'
            style={{ width: 'inherit' }}
          >
            {title}
          </button>
        )}
      </Fragment>
    );
  }
}

OfferAction.propTypes = {
  client: PropTypes.object.isRequired,
  handleSnackbarError: PropTypes.func.isRequired,
  setSnackbarMessage: PropTypes.func.isRequired,
  offerId: PropTypes.string.isRequired,
  mutation: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  dialogBody: PropTypes.string.isRequired,
  refetchQueries: PropTypes.array,
  enableMessage: PropTypes.bool.isRequired,
  linkForm: PropTypes.bool,
};

OfferAction.defaultProps = {
  refetchQueries: [],
};

export default connect()(withApollo(withAlertHandler(OfferAction)));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/RequestInformationButton/RequestInformationAction.js